module.exports = __webpack_public_path__ + "media/assets/community/logo-pd-cb5ad6bcd2f911225114288572b88838ad33aa2dcb59290c99d3d2c3b6a5ff51.png";